var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post"},[_c('div',{staticClass:"post-body"},[_c('div',{staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.post)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }